/**
 * Scale of image provided by Wolt image proxy.
 * https://github.com/creditornot/image-resizer/blob/main/src/imageConfig.ts
 */
export type ResizedImageWidth = 200 | 300 | 600 | 960 | 1200 | 1600 | 1920;

const URLS_SUPPORTING_WIDTH = [
  'wolt-menu-images-cdn.wolt.com',
  'imageproxy.wolt.com',
  'image-resizer-proxy.development.dev.woltapi.com',
];

export function getResizedImageUrl(src: string | undefined, width: ResizedImageWidth | undefined) {
  if (src && width && URLS_SUPPORTING_WIDTH.some((url) => src.includes(url))) {
    const url = new URL(src, window.location.href);
    url.searchParams.set('w', width.toString());
    return url.toString();
  }

  return src;
}
